export default [
    {
        path: '',
        name: 'serviceDetail',
        component: () => import('./page-service-detail'),
        props: true
    }
]